namespace TabAurous.ProductDevelopment {
    export namespace SpecSheetItemsSelectService {
        export const baseUrl = 'ProductDevelopment/SpecSheetItemsSelect';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SpecSheetItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ProductDevelopment/SpecSheetItemsSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>SpecSheetItemsSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
